import type {
    MonitorStatisticTimeseries,
    TagStatisticTimeseries,
    TagStatisticTimeseriesPoint,
} from '../../domain/model/MonitorStatisticTimeseries.types';
import { toTag } from './events.mapper';
import type * as api from './generated/api';

export const toMonitorStatisticTimeseries = (apiData: api.MonitorStatisticTimeseries): MonitorStatisticTimeseries => ({
    id: apiData.id,
    timeseries: apiData.timeseries.map(toTagStatisticTimeseries),
});

const toTagStatisticTimeseries = (apiData: api.TagStatisticTimeseries): TagStatisticTimeseries => ({
    tag: toTag(apiData.tag),
    label: apiData.label,
    unit: apiData.unit,
    timeseries: apiData.timeseries.map(toTagStatisticTimeseriesPoint),
});

const toTagStatisticTimeseriesPoint = (apiData: api.TagStatisticTimeseriesPoint): TagStatisticTimeseriesPoint => ({
    timestamp: apiData.timestamp,
    value: apiData.value,
    standardError: apiData.standardError,
});
